<template>
  <div class="container">

    <section class="spread">
      <NetworkAlert :title="'Erreur 404'" defaultLink='home'>
        <p>
          Cette page n'existe pas.
        </p>
      </NetworkAlert>
    </section>

  </div>
</template>

<script>
import NetworkAlert from '@/components/NetworkAlert.vue'

export default {
  components: {
    NetworkAlert
  }
}
</script>

<style scoped>

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
}
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue